import type { IconProps } from "./icon-types";

/**
 * 하나의 녹화 episode. media file silhouette와 play glyph를 결합해 frame/annotation과 구분한다.
 *
 * sigmakit-gui의 episode list에서 사용하던 `react-icons/lu`의 `LuFileVideo`
 * (Lucide `file-video`) path를 c6 공용 글리프로 이관했다. c6 패키지는 외부 아이콘
 * 라이브러리를 런타임 import하지 않으므로(RFC-design-system-split §아이콘) SVG anatomy만 재현한다.
 */
export const EpisodeIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    <path d="m10 11 5 3-5 3v-6Z" />
  </svg>
);
